var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentInfoLinks',{attrs:{"links":_vm.links}})
}
var staticRenderFns = []

export { render, staticRenderFns }